/**
 * The phone app's own words (piece 35; decisions 3420, 3421), kept beside its
 * rules and spread into the one string lookup. A word the web already says,
 * such as Sign in, Email or Sign Out, is read from the web's own key and is not
 * repeated here.
 */
export const MOBILE_STRINGS = {
  'mobile.session.checking': 'Checking your sign-in…',
  'mobile.session.ended': 'Your session ended. Sign in again to continue.',
  'mobile.read.unreachable': 'The server did not answer. Check the connection, then pull down to read again.',
  'mobile.read.answered': 'The server answered',
  'mobile.signIn.enrolOnWeb': 'This login has no authenticator yet. Finish the first sign-in on the web, then sign in here.',
  'mobile.signIn.passwordOnWeb': 'This login still has to set its own password. Set it on the web, then sign in here.',
  'mobile.signIn.refused': 'The server refused the sign-in.',
  'mobile.list.search': 'Search',
  'mobile.list.noMatch': 'Nothing matches the search.',
  'mobile.list.shown': 'shown of',
  'mobile.record.back': '‹ Back',
  'mobile.record.fieldsOnWeb': 'This record’s own fields are changed on the web.',
  'mobile.choice.pick': 'Choose One',
  'mobile.record.moreContact': 'Add Contact Detail',
  'mobile.record.moreCustomFields': 'Edit Custom Fields',
  'mobile.account.menu': 'Account Menu',
  // Decision 9220 (row T3313): the drawer's foot names the update the phone runs.
  'mobile.build.update': 'Update {id}, {date}',
  'mobile.build.development': 'Development build',
  'mobile.kept.needsSignal': 'This phone does not keep this record, so it opens only with a signal.',
  'mobile.kept.at': 'Kept',
  'mobile.kept.listOffline': 'No signal: showing only the records this phone keeps, and the search reads only them.',
  'mobile.kept.jobsOffline': 'No signal: showing only the jobs this phone keeps, and the Service Reports it kept beside them.',
  'mobile.kept.noStore.opening': "This phone's store is still opening.",
  'mobile.kept.noStore.expoGo': 'This app keeps no records on the phone because it runs inside Expo Go.',
  'mobile.kept.noStore.web': 'This app keeps no records on the phone because it runs in a browser.',
  'mobile.kept.noStore.unlockedBuild': 'This build keeps no records on the phone.',
  'mobile.kept.noStore.noCipher': 'This phone cannot seal a store, so it keeps no records.',
  'mobile.kept.noStore.newerSchema': 'This phone holds a store from a newer version of the app, so it keeps no records until the app is updated.',
  'mobile.kept.noStore.failed': "This phone's store could not be opened.",
  'mobile.kept.noStore.noOwner': 'This phone does not know who signed in, so it keeps no records until it reaches the server once.',
  // 🔒 Decision 7607 (row T3107): the phone's act words are Title Case and one word does one act, so the phone reads its own where the web's key is in sentence case.
  'mobile.act.backToSignIn': 'Back to Sign In',
  'mobile.act.seeAllTodos': 'See All To-Dos',
  'mobile.act.thisPerson': 'This Person',
  'mobile.act.somebodyElse': 'Somebody Else',
  'mobile.act.keepBoth': 'Keep Both',
  'mobile.act.editOccupancy': 'Edit This Occupancy',
  'mobile.act.editEmployment': 'Edit This Employment',
  'mobile.act.editNote': 'Edit Note',
  'mobile.act.deleteReply': 'Delete Reply',
  'mobile.act.checkOut': 'Check Out',
  'mobile.act.openRecord': 'Open the Record',
  'mobile.act.openPastedLink': 'Open the Pasted Maps Link',
  'mobile.sure': 'Are you sure?',
  // 🔒 Decision 7601 (row T3107): a removal of saved data asks through the confirm sheet, naming what comes off.
  'mobile.remove.tagTitle': 'Remove this tag?',
  'mobile.remove.tagBody': 'The tag comes off this record. It stays on the records that carry it.',
  'mobile.remove.tagAct': 'Remove Tag',
  'mobile.remove.replyTitle': 'Delete this reply?',
  'mobile.remove.replyBody': 'The reply comes off the note for everyone who reads it.',
  'mobile.remove.pictureTitle': 'Remove this picture?',
  'mobile.remove.pictureBody': 'The record goes back to having none.',
  'mobile.remove.pinTitle': 'Clear the pin?',
  'mobile.remove.pinBody': 'The location keeps its address and loses its saved point.',
  'mobile.remove.answerTitle': 'Clear this answer?',
  'mobile.remove.answerBody': 'The answer comes off the question, and you can type another.',
  // 🔒 Decision 7606 (row T3107): one busy word, one last-read sentence with its noun, and one pair of whole-page refusals.
  'mobile.state.loading': 'Loading…',
  'mobile.state.working': 'Working…',
  // 🔒 Decision 7604 (row T3107): a required field's problem reads under the field, and a held Save says why.
  'mobile.form.requiredField': 'This field is required.',
  'mobile.form.requiredHeld': 'Save is held until every required field is filled in.',
  'mobile.lastRead': 'Showing the last {noun} read.',
  'mobile.noun.list': 'list',
  'mobile.noun.record': 'record',
  'mobile.noun.report': 'report',
  'mobile.noun.board': 'board',
  'mobile.noun.document': 'document',
} as const;
